import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { sendForgotPasswordOtp, resetPassword } from "../Common/apis.js";
import Loader from "../Loader/Loader.jsx";
import Navbar from "../Components/Navbar";
import img from "../Assets/Mobile login-pana 2.png";
import Footer from "../Components/Footer";
import Aos from "aos";

const ForgotPassword = () => {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  const [step, setStep] = useState(1); // Step 1 = Email, Step 2 = OTP + New Password
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isValidOtp = (otp) => {
    return /^\d{6}$/.test(otp);
  };

  const isValidPassword = (password) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/.test(password);
  };


  // Step 1: Send OTP
  const handleSendOtp = async () => {
    if (!email) return toast.error("Please enter your email.");
    if (!isValidEmail(email)) return toast.error("Invalid email format.");
    setLoading(true);
    try {
      await sendForgotPasswordOtp({ email });
      toast.success("OTP sent successfully. Check your email.");
      setStep(2);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Verify OTP & Reset Password
  const handleResetPassword = async () => {
    if (!otp || !newPassword) return toast.error("Please fill all fields.");
    if (!isValidOtp(otp)) return toast.error("Invalid OTP. OTP must be 6 digits.");
    if (!isValidPassword(newPassword)) return toast.error("Password must be at least 6 characters long, contain an uppercase letter, a lowercase letter, and a number.");

    setLoading(true);
    try {
      await resetPassword({ email, otp, password: newPassword });
      toast.success("Password reset successfully. Please login.");
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-div">
      <Navbar />
      {loading && <Loader />}

      <div className="New-login">
        {/* Left Side */}
        <div className="New-login-left">
          <div data-aos="fade-down" className="b1"><h2>Have Your Own</h2></div>
          <br />
          <div data-aos="fade-up" className="b2"><h2>Account With Us</h2></div>
          <br />
          <div className="Register-div">
            <p data-aos="fade-up">If you don’t have an account, register</p>
            <p data-aos="fade-up">
              You can{" "}
              <Link to="/singup" style={{ color: "blueviolet" }}>Register here</Link> !!
            </p>
            <br />
            <div data-aos="flip-up" className="cnt"><img src={img} alt="Forgot Password" /></div>
          </div>
        </div>

        {/* Right Side */}
        <div className="New-login-right lg:!mr-[90px] !mr-auto lg:ml-0 ml-auto  max-w-[539px] w-full">
          <div data-aos="fade-left" className="login-form">
            <div className="login-heading">
              <p className="poppins md:text-[21px] text-[16px] font-[400]">Welcome to <span className="text-[#6953A3] italic !font-[900]"> GISUL</span></p>
              <h6 className="md:pt-0 pt-[11px]">
                If you don’t have an account register<br />
                <Link to="/singup" style={{ color: "#075D9D" }}>Register here</Link>
              </h6>
            </div>
<br />
            <h3 className="lg:!text-[46px] !text-[30px]">Forgot Password</h3>

            {/* Step 1: Enter Email to Get OTP */}
            {step === 1 && (
              <div className="ips">
                <br />
                <label className="label-default">Enter your email address</label>
                <input
                  type="email"
                  className="input-default"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                />
                <br />
                <button onClick={handleSendOtp}>Send OTP</button>
              </div>
            )}

            {/* Step 2: Enter OTP & New Password */}
            {step === 2 && (
              <div className="ips">
                <br />
                <label className="label-default">Enter OTP</label>
                <input
                  className="input-default"
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter OTP"
                />
                <br />
                <label className="label-default">Enter New Password</label>
                <input
                  className="input-default"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                />
                <br />
                <button onClick={handleResetPassword}>Reset Password</button>
              </div>
            )}

            <br />
            <p onClick={() => navigate("/login")} style={{ cursor: "pointer", color: "#075D9D" }}>
              Back to Login
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ForgotPassword;
